// 用户列表
export default {
    heard_title: "User list",
    heard_btn: "User registration",
    fl_mobile: "Mobile phone number",
    fl_nickName: "Nickname:",
    fl_status: "Status:",
    fl_startTime: "Registration time:",
    fp_mobile: "phone number",
    fp_nickName: "nickname",
    fp_status: "account status",
    fp_startTime: "Pick a start date",
    fp_endTime: "Pick an end date",
    op_all: "All",
    op_approved: "Normal",
    op_frozen: "Close",
    tl_account: "User Account",
    tl_nickName: "User Nickname",
    tl_level: "Level",
    tl_experience: "Experience Points",
    tl_balance: "Available Balance",
    tl_consumeAount: "Consumption Amount",
    tl_orderQuantity: "Order Quantity",
    tl_status: "Status",
    btn_recharge: "Recharge",
    btn_view: "View",
    pay_number: "Payment Amount",
    pay_unit: "Yuan",
    pay_way: "payment method",
    dt_recharge: "Top-up",
    dl_amount: "Recharge amount:",
    dl_payModel: "Payment method:",
    dialog_label3: "Payment code:",
    dl_authCode: "Payment code:",
    dl_earnedRates: "earnedRates",
    dl_change: "change",
    dl_rewoadAmount: "Top-up activity:",
    dl_discount: "Membership card recharge:",
    dp_amount: "recharge amount",
    dp_payModel: "payment method",
    dp_authCode: "scan the payment code",
    dp_rewoadAmount: "Please select",
    dp_discount: "Please select",
    vx_pay: "WeChat Payment",
    cash_pay: "Cash",
    pos_pay: "swipe card",
    other_pay: "Other",
    ali_pay: "Alipay",
    dt_register: "Register",
    dt_nickName: "Nickname",
    dt_mobile: "Mobile phone number",
    dt_gender: "Gender",
    dt_age: "Birthday",
    radio_male: "Male",
    radio_famale: "Female",
    em_mobile: "Please enter your phone number",
    em_mobileFomat: "Please enter the correct mobile phone number",
    em_nickName: "Please enter a nickname",
    sm_register: "Registration successful",
    em_register: "Registration failed",
    pay_tip1: "Successful payment",
    pay_tip2: "Payment failed",
    pay_tip3: "Payment result unknown",
    pay_step1: "OK",
    pay_step2: "Repay",
    ft_wechatpay: "Wechat Pay",
    ft_alipay: "Alipay",
    ft_wallet: "Membership Card",
    ft_cash: "Cash",
    ft_pos: "swipe card",
    ft_other: "Other"
};
